module.exports = __webpack_public_path__ + "static/media/photo115.d45d96f7.jpg";